import { supabase } from './supabase';

type Result<T>={data:T|null;error:{message:string}|null};
export type LeadQualification={account_id:string|null;contact_id:string|null;opportunity_id:string};

export const salesLeadApi={
 async qualify(leadId:string):Promise<Result<LeadQualification>>{
  const r=await supabase.rpc('qualify_lead',{p_lead_id:leadId});
  const raw=Array.isArray(r.data)?r.data[0]:r.data;
  return{data:(raw??null) as LeadQualification|null,error:r.error?{message:r.error.message}:null};
 },
};
